import cn from 'classnames';
import Link from 'next/link';
import { HTMLAttributes } from 'react';
import { HOME_PATHNAME } from '@/shared/constants/pathnames';
import styles from './auth-card.module.scss';


export function AuthCardLogo ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={ cn(styles.logo, className) }
            data-template="auth-card-logo"
            { ...props }
        >
            <Link
                prefetch={ false }
                href={ HOME_PATHNAME }
            >
                <div className={ styles.logo_img }/>
            </Link>
        </div>
    );
}
